import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${commonStyles}`), unsafeCSS(`${colorHelpersStyles}`)];
